const BUOY_DATA = {
  type: 'FeatureCollection',
  totalFeatures: 93,
  features: [
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fc0',
      geometry: null,
      properties: {
        timestamp: '2015-02-11T00:00:00Z',
        ice_thickness: '77.5',
        snow_depth: '7.5',
        tair_mean: '-22.84111111',
        tice_mean: '-13.02366667',
        tocean_mean: '-2.4275',
        tsnow_mean: '-23'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fbf',
      geometry: null,
      properties: {
        timestamp: '2015-02-12T00:00:00Z',
        ice_thickness: '78.75',
        snow_depth: '10',
        tair_mean: '-21.62625',
        tice_mean: '-12.55451613',
        tocean_mean: '-2.62',
        tsnow_mean: '-21.97333333'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fbe',
      geometry: null,
      properties: {
        timestamp: '2015-02-13T00:00:00Z',
        ice_thickness: '78.75',
        snow_depth: '9.25',
        tair_mean: '-20.96222222',
        tice_mean: '-12.02645161',
        tocean_mean: '-2.760625',
        tsnow_mean: '-20.91666667'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fbd',
      geometry: null,
      properties: {
        timestamp: '2015-02-14T00:00:00Z',
        ice_thickness: '85',
        snow_depth: '10',
        tair_mean: '-16.6675',
        tice_mean: '-10.62333333',
        tocean_mean: '-2.314615385',
        tsnow_mean: '-16.77666667'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fbc',
      geometry: null,
      properties: {
        timestamp: '2015-02-15T00:00:00Z',
        ice_thickness: '85',
        snow_depth: '7.5',
        tair_mean: '-20.83333333',
        tice_mean: '-11.51333333',
        tocean_mean: '-2.384615385',
        tsnow_mean: '-21.375'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fbb',
      geometry: null,
      properties: {
        timestamp: '2015-02-16T00:00:00Z',
        ice_thickness: '85',
        snow_depth: '8',
        tair_mean: '-19.46222222',
        tice_mean: '-11.38181818',
        tocean_mean: '-2.43',
        tsnow_mean: '-19.53'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fba',
      geometry: null,
      properties: {
        timestamp: '2015-02-17T00:00:00Z',
        ice_thickness: '85',
        snow_depth: '10',
        tair_mean: '-14.51125',
        tice_mean: '-10.20181818',
        tocean_mean: '-2.486153846',
        tsnow_mean: '-14.86'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fb9',
      geometry: null,
      properties: {
        timestamp: '2015-02-18T00:00:00Z',
        ice_thickness: '85',
        snow_depth: '7.5',
        tair_mean: '-17.31555556',
        tice_mean: '-10.83606061',
        tocean_mean: '-2.506923077',
        tsnow_mean: '-18.25'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fb8',
      geometry: null,
      properties: {
        timestamp: '2015-02-19T00:00:00Z',
        ice_thickness: '87.5',
        snow_depth: '5',
        tair_mean: '-20.359',
        tice_mean: '-10.90441176',
        tocean_mean: '-2.340833333',
        tsnow_mean: '-20.5'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fb7',
      geometry: null,
      properties: {
        timestamp: '2015-02-20T00:00:00Z',
        ice_thickness: '85',
        snow_depth: '5',
        tair_mean: '-16.967',
        tice_mean: '-10.81606061',
        tocean_mean: '-2.571538462',
        tsnow_mean: '-17.17'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fb6',
      geometry: null,
      properties: {
        timestamp: '2015-02-21T00:00:00Z',
        ice_thickness: '90',
        snow_depth: '25',
        tair_mean: '-6.6',
        tice_mean: '-8.118857143',
        tocean_mean: '-2.288181818',
        tsnow_mean: '-6.748333333'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fb5',
      geometry: null,
      properties: {
        timestamp: '2015-02-22T00:00:00Z',
        ice_thickness: '92.5',
        snow_depth: '5',
        tair_mean: '-13.549',
        tice_mean: '-9.083055556',
        tocean_mean: '-2.109',
        tsnow_mean: '-14.58'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fb4',
      geometry: null,
      properties: {
        timestamp: '2015-02-23T00:00:00Z',
        ice_thickness: '95',
        snow_depth: '5',
        tair_mean: '-19.718',
        tice_mean: '-9.742162162',
        tocean_mean: '-1.898888889',
        tsnow_mean: '-20'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fb3',
      geometry: null,
      properties: {
        timestamp: '2015-02-24T00:00:00Z',
        ice_thickness: '95',
        snow_depth: '7.5',
        tair_mean: '-18.15666667',
        tice_mean: '-9.844054054',
        tocean_mean: '-1.917777778',
        tsnow_mean: '-19.25'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fb2',
      geometry: null,
      properties: {
        timestamp: '2015-02-25T00:00:00Z',
        ice_thickness: '100',
        snow_depth: '15',
        tair_mean: '-20.51333333',
        tice_mean: '-9.845897436',
        tocean_mean: '-1.56',
        tsnow_mean: '-20.7'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fb1',
      geometry: null,
      properties: {
        timestamp: '2015-02-26T00:00:00Z',
        ice_thickness: '95',
        snow_depth: '5',
        tair_mean: '-15.21',
        tice_mean: '-10.23648649',
        tocean_mean: '-1.972222222',
        tsnow_mean: '-16.92'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fb0',
      geometry: null,
      properties: {
        timestamp: '2015-02-27T00:00:00Z',
        ice_thickness: '95',
        snow_depth: '10',
        tair_mean: '-21.145',
        tice_mean: '-10.61648649',
        tocean_mean: '-2.018888889',
        tsnow_mean: '-21.27666667'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4faf',
      geometry: null,
      properties: {
        timestamp: '2015-02-28T00:00:00Z',
        ice_thickness: '95',
        snow_depth: '5',
        tair_mean: '-21.808',
        tice_mean: '-11.24810811',
        tocean_mean: '-2.046666667',
        tsnow_mean: '-22.25'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fae',
      geometry: null,
      properties: {
        timestamp: '2015-03-01T00:00:00Z',
        ice_thickness: '95',
        snow_depth: '7.5',
        tair_mean: '-18.04666667',
        tice_mean: '-10.93918919',
        tocean_mean: '-2.101111111',
        tsnow_mean: '-18.25'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fad',
      geometry: null,
      properties: {
        timestamp: '2015-03-02T00:00:00Z',
        ice_thickness: '95',
        snow_depth: '2.5',
        tair_mean: '-12.72',
        tice_mean: '-10.65567568',
        tocean_mean: '-2.148888889',
        tsnow_mean: 'nan'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fac',
      geometry: null,
      properties: {
        timestamp: '2015-03-03T00:00:00Z',
        ice_thickness: '95',
        snow_depth: '5',
        tair_mean: '-17.983',
        tice_mean: '-10.57675676',
        tocean_mean: '-2.203333333',
        tsnow_mean: '-18.25'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fab',
      geometry: null,
      properties: {
        timestamp: '2015-03-04T00:00:00Z',
        ice_thickness: '95',
        snow_depth: '15',
        tair_mean: '-19.93',
        tice_mean: '-10.80216216',
        tocean_mean: '-2.232222222',
        tsnow_mean: '-21.35'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4faa',
      geometry: null,
      properties: {
        timestamp: '2015-03-05T00:00:00Z',
        ice_thickness: '100',
        snow_depth: '20',
        tair_mean: '-16.445',
        tice_mean: '-9.583076923',
        tocean_mean: '-1.738571429',
        tsnow_mean: '-17.485'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fa9',
      geometry: null,
      properties: {
        timestamp: '2015-03-06T00:00:00Z',
        ice_thickness: '100',
        snow_depth: '22.5',
        tair_mean: '-20.91666667',
        tice_mean: '-9.288717949',
        tocean_mean: '-1.75',
        tsnow_mean: '-20.36166667'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fa8',
      geometry: null,
      properties: {
        timestamp: '2015-03-07T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '5',
        tair_mean: '-15.975',
        tice_mean: '-9.21275',
        tocean_mean: '-1.75',
        tsnow_mean: '-19.58'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fa7',
      geometry: null,
      properties: {
        timestamp: '2015-03-08T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '15',
        tair_mean: '-11.345',
        tice_mean: '-9.10475',
        tocean_mean: '-1.774285714',
        tsnow_mean: '-16.532'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fa6',
      geometry: null,
      properties: {
        timestamp: '2015-03-09T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '15',
        tair_mean: '-19.26333333',
        tice_mean: '-9.194',
        tocean_mean: '-1.785714286',
        tsnow_mean: '-20.034'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fa5',
      geometry: null,
      properties: {
        timestamp: '2015-03-10T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '15',
        tair_mean: '-18.38833333',
        tice_mean: '-9.20225',
        tocean_mean: '-1.787142857',
        tsnow_mean: '-19.114'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fa4',
      geometry: null,
      properties: {
        timestamp: '2015-03-11T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '15',
        tair_mean: '-9.833333333',
        tice_mean: '-9.29',
        tocean_mean: '-1.81',
        tsnow_mean: '-17.35'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fa3',
      geometry: null,
      properties: {
        timestamp: '2015-03-12T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '15',
        tair_mean: '-15.81833333',
        tice_mean: '-9.1685',
        tocean_mean: '-1.834285714',
        tsnow_mean: '-17.618'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fa2',
      geometry: null,
      properties: {
        timestamp: '2015-03-13T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '20',
        tair_mean: '-20.41666667',
        tice_mean: '-9.202',
        tocean_mean: '-1.845714286',
        tsnow_mean: '-20.40333333'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fa1',
      geometry: null,
      properties: {
        timestamp: '2015-03-14T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '17.5',
        tair_mean: '-18.375',
        tice_mean: '-9.133',
        tocean_mean: '-1.857142857',
        tsnow_mean: '-18.62666667'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4fa0',
      geometry: null,
      properties: {
        timestamp: '2015-03-15T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '25',
        tair_mean: '-9.266',
        tice_mean: '-8.8475',
        tocean_mean: '-1.857142857',
        tsnow_mean: '-17.51333333'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f9f',
      geometry: null,
      properties: {
        timestamp: '2015-03-16T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '25',
        tair_mean: '-11.118',
        tice_mean: '-8.46425',
        tocean_mean: '-1.857142857',
        tsnow_mean: '-15.29166667'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f9e',
      geometry: null,
      properties: {
        timestamp: '2015-03-17T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '27.5',
        tair_mean: '-2.634',
        tice_mean: '-8.08025',
        tocean_mean: '-1.894285714',
        tsnow_mean: '-13.74'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f9d',
      geometry: null,
      properties: {
        timestamp: '2015-03-18T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '15',
        tair_mean: '-7.973333333',
        tice_mean: '-7.6295',
        tocean_mean: '-1.894285714',
        tsnow_mean: '-10.832'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f9c',
      geometry: null,
      properties: {
        timestamp: '2015-03-19T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '27.5',
        tair_mean: '-10.434',
        tice_mean: '-7.19125',
        tocean_mean: '-1.881428571',
        tsnow_mean: '-10.95285714'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f9b',
      geometry: null,
      properties: {
        timestamp: '2015-03-20T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '15',
        tair_mean: '-8.916666667',
        tice_mean: '-6.84575',
        tocean_mean: '-1.881428571',
        tsnow_mean: '-9.95'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f9a',
      geometry: null,
      properties: {
        timestamp: '2015-03-21T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '27.5',
        tair_mean: '-9.684',
        tice_mean: '-6.7625',
        tocean_mean: '-1.87',
        tsnow_mean: '-12.34571429'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f99',
      geometry: null,
      properties: {
        timestamp: '2015-03-22T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '22.5',
        tair_mean: '-0.458333333',
        tice_mean: '-6.536',
        tocean_mean: '-1.881428571',
        tsnow_mean: '-10.48666667'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f98',
      geometry: null,
      properties: {
        timestamp: '2015-03-23T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '30',
        tair_mean: '-2.564',
        tice_mean: '-5.91',
        tocean_mean: '-1.87',
        tsnow_mean: '-4.558571429'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f97',
      geometry: null,
      properties: {
        timestamp: '2015-03-24T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '27.5',
        tair_mean: '-13.168',
        tice_mean: '-6.0915',
        tocean_mean: '-1.844285714',
        tsnow_mean: '-13.43857143'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f96',
      geometry: null,
      properties: {
        timestamp: '2015-03-25T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '27.5',
        tair_mean: '-11.75',
        tice_mean: '-6.05475',
        tocean_mean: '-1.844285714',
        tsnow_mean: '-12.70142857'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f95',
      geometry: null,
      properties: {
        timestamp: '2015-03-26T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '22.5',
        tair_mean: '-11.79166667',
        tice_mean: '-6.17425',
        tocean_mean: '-1.844285714',
        tsnow_mean: '-13.68166667'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f94',
      geometry: null,
      properties: {
        timestamp: '2015-03-27T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '22.5',
        tair_mean: '-5.498333333',
        tice_mean: '-6.0735',
        tocean_mean: '-1.844285714',
        tsnow_mean: '-12.95833333'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f93',
      geometry: null,
      properties: {
        timestamp: '2015-03-28T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '22.5',
        tair_mean: '-13.07',
        tice_mean: '-6.27725',
        tocean_mean: '-1.832857143',
        tsnow_mean: '-14.86166667'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f92',
      geometry: null,
      properties: {
        timestamp: '2015-03-29T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '22.5',
        tair_mean: '-8.415',
        tice_mean: '-6.13275',
        tocean_mean: '-1.832857143',
        tsnow_mean: '-12.36166667'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f91',
      geometry: null,
      properties: {
        timestamp: '2015-03-30T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '15',
        tair_mean: '-5.071666667',
        tice_mean: '-5.971',
        tocean_mean: '-1.832857143',
        tsnow_mean: '-10.4'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f90',
      geometry: null,
      properties: {
        timestamp: '2015-03-31T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '37.5',
        tair_mean: '-5.415',
        tice_mean: '-5.64025',
        tocean_mean: '-1.845714286',
        tsnow_mean: '-7.29125'
      }
    },
    {
      type: 'Feature',
      id: 'SmartIceBuoy.fid--69589863_15f39cbf79a_-4f8f',
      geometry: null,
      properties: {
        timestamp: '2015-04-01T00:00:00Z',
        ice_thickness: '105',
        snow_depth: '27.5',
        tair_mean: '-2.832',
        tice_mean: '-5.37725',
        tocean_mean: '-1.845714286',
        tsnow_mean: '-6.844285714'
      }
    }
  ],
  crs: null
}

export default BUOY_DATA



// WEBPACK FOOTER //
// ./src/config/buoyDataClean.js